/**
 * Adressen for spillestedets «Personer» (`/venue/$festivalId/people`): fanen Mannskap, Vaktplan eller
 * Poster (F39), og uka i vaktplanen (F60: `?week=2026-10-05`, mandagen), så en omlasting eller en
 * lenke til en kollega lander på samme uke. Valideres i kanten.
 */
export const VENUE_CREW_TABS = ['people', 'plan', 'posts'] as const;
export type VenueCrewTab = (typeof VENUE_CREW_TABS)[number];

export interface VenueCrewSearch {
  tab?: VenueCrewTab;
  /** Mandagen i uka vaktplanen viser, `YYYY-MM-DD`. */
  week?: string;
}

const DATE = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/u;

export function validateVenueCrewSearch(search: Record<string, unknown>): VenueCrewSearch {
  const out: VenueCrewSearch = {};
  const tab = search['tab'];
  if (typeof tab === 'string' && (VENUE_CREW_TABS as readonly string[]).includes(tab)) {
    out.tab = tab as VenueCrewTab;
  }
  const week = search['week'];
  if (typeof week === 'string' && DATE.test(week)) out.week = week;
  return out;
}
